import React from "react";
import { Layout } from "views/Main/Layouts";
import { useSelector } from "react-redux";
import { State } from "store";
import { THEME_DEFAULT } from "store/userMeta";
import failLight from "assets/images/Fail-Light.svg";
import failDark from "assets/images/Fail-Dark.svg";
import { Link } from "polyrouter";
import { useTranslation } from "utilities/i18n";
import { generatePath } from "react-router";
import "./Error.scss";

const Error: React.FC = () => {
  const { Content } = Layout;
  const theme = useSelector((state: State) => {
    return state.userMeta?.theme ?? THEME_DEFAULT;
  }).toLowerCase();
  const { t } = useTranslation();

  return (
    <div className={`main theme-${theme} full-height error-page`}>
      <Layout className="full-height">
        <Content className="vertically-centered text-center p-2">
          <h1 className="text-xxxl mb-1">{t("HOUSTON")}</h1>
          <img
            className="mb-4"
            src={theme === "light" ? failLight : failDark}
            alt="Fail Screen"
          />
          <div>
            <h4 className="mb-2">{t("FAIL_SCREEN")}</h4>
            <Link to={generatePath("/home")} className="btn btn-primary">
              {t("REFRESH")}
            </Link>
          </div>
        </Content>
      </Layout>
    </div>
  );
};

export default Error;
